// @flow
import { ConfigInfotoolsActionTypes } from './constants';

type ConfigInfotoolsAction = { type: string, payload: {} | string };

// common success
export const configInfotoolsApiResponseSuccess = (actionType: string, data: any): ConfigInfotoolsAction => ({
    type: ConfigInfotoolsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const configInfotoolsApiResponseError = (actionType: string, error: string): ConfigInfotoolsAction => ({
    type: ConfigInfotoolsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getConfigInfotools = (id: string): ConfigInfotoolsAction => ({
    type: ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS,
    payload: { id },
});

export const addConfigInfotools = (config:any):ConfigInfotoolsAction=>({
    type:ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS,
    payload:config
})
export const updateConfigInfotools = (config:any):ConfigInfotoolsAction=>({
    type:ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS,
    payload:config
})
export const deleteConfigInfotools = (id:string):ConfigInfotoolsAction=>({
    type:ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS,
    payload:{id}
})

export const listConfigsInfotools = (params:any): ConfigInfotoolsAction => ({
    type: ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS,
    payload: params,
});


export const resetConfigsInfotools = (): ConfigInfotoolsAction => ({
    type: ConfigInfotoolsActionTypes.RESET,
    payload: {},
});

